/**
 * Order / invoice emails, delivered by the Node + Express + MariaDB backend
 * (`POST /api/admin/erp/send-email`). The backend holds the Resend credentials,
 * so no secrets ever reach the browser.
 */
import { apiPostAuth, isApiConfigured } from "./http";

export interface ErpEmailPayload {
  type: "order" | "invoice";
  to: string;
  reference: string;
  customer: string;
  business?: string;
  plan?: string;
  amount?: number;
  tax?: number;
  total?: number;
  currency?: string;
  status?: string;
  issuedAt?: string;
  dueAt?: string;
}

/** Send an order / invoice email. Throws a friendly error on failure. */
export async function sendErpEmail(
  token: string | null,
  payload: ErpEmailPayload,
): Promise<string> {
  if (!isApiConfigured() || !token) {
    throw new Error("Email sending is unavailable in demo mode — connect the backend to enable it.");
  }
  const res = await apiPostAuth<{ message?: string }>("/admin/erp/send-email", payload, token);
  return res?.message ?? "Email sent.";
}